// import MainMenu from 'src/components/MainMenu';
// import useToggle from '../components/hooks/useToggle';
import { useLayoutEffect } from 'react';
import WorkArea from '../components/WorkArea';
import ModalError from 'src/components/error';
import { useLocation } from 'react-router-dom';

function App() {
  const location = useLocation();
  // const { onToggle, toggle } = useToggle(false);
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      {/* <MainMenu isOpen={toggle} onToggle={onToggle}></MainMenu> */}
      <WorkArea />
      <ModalError />
    </>
  );
}

export default App;
